import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { ArenaChallengeListItem, listChallenges } from '../../api/group/arena.api';
import { formatVn } from './arena-format';

const GROUPS: Array<{ status: string; title: string }> = [
  { status: 'PUBLISHED', title: 'Đang mở' },
  { status: 'JUDGING', title: 'Đang chấm' },
  { status: 'FINALIZED', title: 'Đã có kết quả' },
];

export const myTeamText = (c: ArenaChallengeListItem) => {
  if (!c.myTeamId) return 'Bạn chưa có đội';
  const name = /^đội\s/i.test(c.myTeamName || '') ? c.myTeamName : `Đội ${c.myTeamName}`;
  return c.myTeamHasEntry ? `${name}, đã nộp bài` : `${name}, chưa nộp bài`;
};

const ArenaListPage: React.FC = () => {
  const [items, setItems] = useState<ArenaChallengeListItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listChallenges()
      .then(setItems)
      .catch((e: any) => toast.error(e?.message || 'Không tải được danh sách thử thách'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex min-h-[300px] items-center justify-center">
        <Spin />
      </div>
    );
  }

  return (
    <div className="mx-auto flex w-full max-w-[900px] flex-col gap-8 px-6 py-6">
      <h1 className="text-[24px] font-bold text-[#19052f] dark:text-slate-100">Arena</h1>
      {GROUPS.map((g) => {
        const rows = items.filter((c) => c.status === g.status);
        return (
          <section key={g.status} className="flex flex-col gap-3">
            <h2 className="text-[18px] font-semibold text-[#19052f] dark:text-slate-100">{g.title}</h2>
            {rows.length === 0 ? (
              <div className="text-[14px] text-[#657384] dark:text-slate-400">Chưa có thử thách nào.</div>
            ) : (
              rows.map((c) => (
                <Link
                  key={c.id}
                  to={`/arena/${c.id}`}
                  className="flex flex-col gap-1 rounded-[16px] border border-[#DEE0E6] p-4 transition hover:shadow-md dark:border-slate-700"
                >
                  <div className="text-[16px] font-semibold text-[#19052f] dark:text-slate-100">{c.title}
                    {c.type === 'CLAN_WAR' && (
                      <span className="ml-2 rounded-full bg-[#FEE2E2] px-2 py-[1px] align-middle text-[11px] font-medium text-[#B91C1C]">
                        Clan chiến
                      </span>
                    )}
                  </div>
                  <div className="text-[13px] text-[#657384] dark:text-slate-400">
                    {formatVn(c.startAt)} đến {formatVn(c.submitDeadline)}
                  </div>
                  <div className="text-[13px] text-[#066bff]">{myTeamText(c)}</div>
                </Link>
              ))
            )}
          </section>
        );
      })}
    </div>
  );
};

export default ArenaListPage;
